'use strict';

/**
 * Model for a conversation post
 *
 * @category   Model
 * @module     community
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Model = require('base/Colido.Model');

var ConversationPostModel = Model.extend({
    urlRoot: false, //use api from collection. Pass {collection: ...} as option when initializing model. See commandSendMessageToConversation()

    defaults: function(){ //use function, cause objects are passed by reference
        return {
            conversationId: null, //Integer
            userId: null, //Integer
            type: 'text', //String
            data: null, //String|Object
            created: null, //Integer
            modified: null, //Integer
            deleted: false, //Boolean
        };
    },

    customAttributes: {
        authorData: function() {
            var authorData = this.collection.conversation.getUserDataById(this.get('userId'));

            return authorData;
        },
    },
});

module.exports = ConversationPostModel;